import clsx from "clsx";
import type { ComponentProps } from "react";

import { EventCard } from "@entities/event-card";

import { Heading } from "@shared/ui/typography";

import type { EventType } from "@/_pages/event/model";

import s from "./coming-events.module.scss";

export type CompProps = ComponentProps<"div"> & {
  events: EventType[];
};

export const ComingEvents = (props: CompProps) => {
  const { events } = props;

  return (
    <section className={clsx(s.root)}>
      <div className={s.content}>
        <div className={s.navigation}>
          <Heading level={3} className={s.title}>
            Ближайшие мероприятия
          </Heading>
        </div>
        <div className={s.cards}>
          {events.map((event) => (
            <EventCard key={event.documentId} event={event} />
          ))}
        </div>
      </div>
    </section>
  );
};

ComingEvents.displayName = "ComingEvents";
